export const modelUniqueness: { [key: string]: boolean } = {
    VP1PK001: true, // Expert Combi
    VP1PK900: true, // Rifter
    VP1PP100: true, // 2008
    VP11PP20: true, // 208
    VP1PP7CM: true, // 5008
    VP1PP8SY: true, // 3008
    VP1PB100: false, // 108
    VP1PK000: false, // Traveller
    VP1PR800: false, // 508
    VP1PT900: false, // 308
    VPAC0020: true, //  Spacetourer business
    VPAC0025: true, // Grand C4 Spacetourer
    VPAC0008: true, // C4 Cactus Berline
    VPAC0005: true, // C3 Berline
    VPAC0028: true, // C5 Aircross hybrid
    '00001568': true, // UK - C3 Aircross SUV
    '00001601': true, // UK - Grand C4 Spacetourer
    '00000163': true, // UK - C3 New
    '0V001617': true, // UK - C5 Aircross SUV
};

export const validUnits = ['bhp', 'l/100km', 'g/km', 'kW', 'kWh', 'Wh'];

/**
 * Function compares two strings and returns the differences from second parameter string
 * e.g.: twoStringDifference('Spacetourer Business', 'Spacetourer Business Lounge') => 'Lounge'
 * e.g.: twoStringDifference('Berlingo', 'Taille M') => 'Taille M'
 * @param original
 * @param toBeCompared
 */
export const twoStringDifference: (original: string, toBeCompared: string) => string = (
    original: string,
    toBeCompared: string
) => toBeCompared.split(original).join('');

export const getBodyStyleDescription = (modelTitle: string, grBodyStyleDescription: string, modelId: string) => {
    if (modelUniqueness[modelId]) {
        return '';
    }

    return !grBodyStyleDescription.includes(modelTitle) ? grBodyStyleDescription.trim() + ' ' : '';
};

export const getModelTitle = (carDetails: any, shouldIncludeBodyStyleDescription: boolean = true) => {
    if (carDetails && carDetails.model) {
        if (!shouldIncludeBodyStyleDescription) {
            return carDetails.model.description;
        }

        const grBodyStyle = carDetails?.extraFields?.grBodyStyle || carDetails?.grBodyStyle;
        const bodyStyleDescription = getBodyStyleDescription(
            carDetails.model.description,
            grBodyStyle?.description ?? '',
            carDetails.model.id
        );

        return `${carDetails.model.description}${' '}${bodyStyleDescription && bodyStyleDescription}`;
    } else {
        return ``;
    }
};

export const getTrimContent = (carDetails: any) => {
    return carDetails?.extraFields?.trimContent || {};
};

export const replaceRange = (input: string, startIndex: number, endIndex: number, substitute: string) =>
    input.substring(0, startIndex) + substitute + input.substring(endIndex);

const formatUnit = (input: string, unit: string) => {
    const searchRegex = new RegExp(`\\b${unit.toLowerCase()}\\b`, 'g');
    const results = input.toLowerCase().matchAll(searchRegex);

    return Array.from(results).reduce(
        (formattedInput, result) => replaceRange(formattedInput, result.index, result.index + unit.length, unit),
        input
    );
};

export const formatUnits = (input: string) =>
    validUnits.reduce((formattedInput, unit) => formatUnit(formattedInput, unit), input);
